const ANIME_KIND_LABELS = {
    tv: 'TV',
    ova: 'OVA',
    ona: 'ONA',
    movie: 'Фильм',
    special: 'Спецвыпуск',
    tv_special: 'Спецвыпуск',
    music: 'Музыкальное видео',
    cm: 'Реклама',
    pv: 'Промо',
    serial: 'Сериал',
    anime: 'Аниме',
}

function positiveInteger(value) {
    let number = Number(value)
    return Number.isInteger(number) && number > 0 ? number : null
}

function yearFromDate(value) {
    let match = String(value || '').match(/^(\d{4})-/)
    return match ? validYear(match[1]) : null
}

function validYear(value) {
    let year = positiveInteger(value)
    return year && year >= 1900 && year <= 2200 ? year : null
}

const TEXT_BOUNDARY_START = '(?:^|[^\\p{L}\\p{N}])'
const TEXT_BOUNDARY_END = '(?=$|[^\\p{L}\\p{N}])'
const OVA_MARKER = new RegExp(`${TEXT_BOUNDARY_START}(?:OVA|ОВА)${TEXT_BOUNDARY_END}`, 'iu')
const ONA_MARKER = new RegExp(`${TEXT_BOUNDARY_START}ONA${TEXT_BOUNDARY_END}`, 'iu')
const SEASON_MARKER = new RegExp(
    `(?:\\[\\s*(?:тв|tv)(?:\\s*-?\\s*\\d+)?(?:\\s*,[^\\]]*)?\\s*\\]|${TEXT_BOUNDARY_START}(?:сезон|season)\\s+\\d+${TEXT_BOUNDARY_END}|${TEXT_BOUNDARY_START}\\d+(?:st|nd|rd|th)?\\s+(?:сезон|season)${TEXT_BOUNDARY_END})`,
    'iu'
)
const SPECIAL_MARKER = new RegExp(
    `${TEXT_BOUNDARY_START}(?:спецвыпуск|special)${TEXT_BOUNDARY_END}`,
    'iu'
)
const EXPLICIT_SEASON_MARKER = new RegExp(
    `(?:\\[\\s*(?:тв|tv)\\s*-?\\s*(\\d{1,2})(?:\\s*,[^\\]]*)?\\s*\\]|${TEXT_BOUNDARY_START}(?:сезон|season)\\s*(\\d{1,2})${TEXT_BOUNDARY_END}|${TEXT_BOUNDARY_START}(\\d{1,2})(?:st|nd|rd|th)?\\s+(?:сезон|season)${TEXT_BOUNDARY_END})`,
    'giu'
)

export function animeReleaseKind(anime) {
    let material = anime && anime['material_data'] || {}
    let kind = String(material['anime_kind'] || '').trim().toLowerCase()
    if (ANIME_KIND_LABELS[kind]) return kind

    let title = [anime && anime['title'], anime && anime['title_orig']]
        .filter(Boolean)
        .join(' ')
    if (OVA_MARKER.test(title)) return 'ova'
    if (ONA_MARKER.test(title)) return 'ona'
    if (SEASON_MARKER.test(title)) return 'tv'
    if (SPECIAL_MARKER.test(title)) return 'special'
    return anime && anime['type'] === 'anime-serial' ? 'serial' : 'anime'
}

export function animeReleaseSeason(anime) {
    if (animeReleaseKind(anime) !== 'tv') return null

    /* last_season — номер последнего сезона в плеере, а не идентификатор
       произведения. Берём только явно подписанный сезон и не угадываем его
       по произвольным числам в названии. */
    let titles = [anime && anime['title'], anime && anime['title_orig']]
    let candidates = new Set()
    for (const title of titles) {
        let matches = String(title || '').matchAll(EXPLICIT_SEASON_MARKER)
        for (const match of matches) {
            let parsed = positiveInteger(match[1] || match[2] || match[3])
            if (parsed && parsed <= 99) candidates.add(parsed)
        }
    }
    return candidates.size === 1 ? [...candidates][0] : null
}

export function animeReleaseYear(anime) {
    let material = anime && anime['material_data'] || {}
    return yearFromDate(material['aired_at'])
        || validYear(anime && anime['year'])
        || validYear(material['year'])
        || null
}

export function formatAnimeReleaseMeta(anime) {
    let kind = animeReleaseKind(anime)
    let season = animeReleaseSeason(anime)
    let year = animeReleaseYear(anime)
    let parts = [ANIME_KIND_LABELS[kind] || 'Аниме']

    if (season) parts.push(`сезон ${season}`)
    if (year) parts.push(String(year))
    return parts.join(' · ')
}
